import { useEffect, useRef, useState } from 'react'
import InputNumberDecimal, { InputProps } from './inputNumberDecimal'

interface InputNumberWithSerialPortProps extends InputProps {
  automatic?: boolean | undefined
  onChangeValueWeight: (value: string) => void
}

const InputNumberWithSerialPort = ({
  automatic = true,
  onChangeValueWeight,
  ...props
}: InputNumberWithSerialPortProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [serialPort, setSerialPort] = useState<SerialPort[] | null>(null)
  const [errors, setErrors] = useState<string | null>(null)
  const [liveWeight, setLiveWeight] = useState<string | null>(null) // peso actual en vivo

  const portRef = useRef<SerialPort | null>(null)
  const readerRef = useRef<ReadableStreamDefaultReader<string> | null>(null)
  const pipePromiseRef = useRef<Promise<void> | null>(null)

  const extractNumber = (value: string) => {
    const matches = value.match(/\d+\.\d{2}/)
    return matches?.[0] ?? null
  }

  const getListPorts = async () => {
    const ports = await navigator.serial.getPorts()
    console.log('Puertos disponibles:', ports)
    // setSerialPort(ports)

    if (ports?.length) {
      listenPort(ports[0])
    } else {
      getDevicePermissions(ports)
    }
  }

  const listenPort = async (port: SerialPort) => {
    setIsLoading(true)
    try {
      if (port.readable && port.writable && port.open) {
        await port.close()
      }

      await port.open({ baudRate: 9600 })
      console.log("abri puerto")
      portRef.current = port

      const decoder = new TextDecoderStream()
      pipePromiseRef.current = port.readable!.pipeTo(decoder.writable)

      const inputStream = decoder.readable
      const reader = inputStream.getReader()
      console.log("lectora")
      readerRef.current = reader

      let pesoFinal = ''
      console.log("antes del bucle")
      while (true) {
        console.log("en el bucle")
        const { value, done } = await reader.read()

        console.log({value, done})
        if (done) break

        pesoFinal += value
        if (value?.includes('G')) {
          const peso = extractNumber(pesoFinal)
          if (peso) {
            setLiveWeight(peso)
            // onChangeValueWeight(peso)
          }
          pesoFinal = ''
          setIsLoading(false)
        }
      }
    } catch (e: any) {
      console.error('Error en listenPort:', e)
      setErrors('Error al intentar leer desde el dispositivo')
      setIsLoading(false)
    }
  }

  const getDevicePermissions = async (ports: any) => {
    try {
      if (ports?.length) {
        listenPort(ports[0])
      } else {
        setIsLoading(true)
        const port = await navigator.serial.requestPort()
        listenPort(port)
      }
    } catch (error: any) {
      const { code } = error
      if (code === 8) {
        setErrors('Has denegado el permiso para acceder al puerto serial')
      } else if (code === 9) {
        setErrors('No se ha encontrado ningún dispositivo')
      } else if (code === 11) {
        setErrors('No se ha podido acceder a la balanza')
      } else {
        setErrors('Error desconocido al acceder al puerto serial')
      }
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getListPorts()
  }, [])

  // useEffect(() => {
  //   if (automatic) {
  //     onChangeValueWeight('')
  //   }
  // }, [automatic])

  // useEffect(() => {
  // if (automatic) {
  //   if (serialPort?.length) {
  //     listenPort(serialPort[0])
  //   } else {
  //     getDevicePermissions()
  //   }
  // }
  // }, [automatic, serialPort])

  useEffect(() => {
    let clearError: NodeJS.Timeout
    if (errors) {
      clearError = setTimeout(() => {
        setErrors(null)
      }, 3000)
    }

    return () => {
      clearTimeout(clearError)
    }
  }, [errors])

  // 👇 Este efecto limpia el puerto al desmontar el componente (ej: cerrar el modal)
  useEffect(() => {
    return () => {
      const closePort = async () => {
        try {
          if (readerRef.current) {
            await readerRef.current.cancel().catch(() => {})
            readerRef.current.releaseLock()
          }

          if (pipePromiseRef.current) {
            await pipePromiseRef.current.catch(() => {})
          }

          if (portRef.current && portRef.current.readable) {
            await portRef.current.close().catch(() => {})
            console.log('Puerto cerrado correctamente al desmontar')
          }
        } catch (error) {
          console.error('Error al cerrar el puerto:', error)
        }
      }

      closePort()
    }
  }, [])

  return (
    <div className="position-relative">
      {automatic && (
        <button
          type="button"
          onClick={() => {
            if (liveWeight) {
              onChangeValueWeight(liveWeight)
            }
          }}
          className="btn btn-secondary btn-sm btn-active-color-gray-700 position-absolute top-0 end-0 me-5"
          data-kt-indicator={isLoading ? 'on' : 'off'}
          style={{ marginTop: '0.65rem' }}
        >
          <span className="indicator-label">Obtener peso</span>
          <span className="indicator-progress">
            Esperando a la balanza...{' '}
            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        </button>
      )}
      <InputNumberDecimal {...props} readonly={automatic} />
      {errors && <p className="text-primary fs-8">{errors}</p>}
    </div>
  )
}

export default InputNumberWithSerialPort